import React from "react";
import PropTypes from "prop-types";
import GoogleMapsLoader from "google-maps";
import { geocodeByAddress } from "react-places-autocomplete";
import { getGeoLocation } from "../helpers";

GoogleMapsLoader.KEY = "AIzaSyBJ5gh-HqMPqJRm81QaXbE825CEH_ECZLo";
GoogleMapsLoader.LIBRARIES = ["geometry", "places"];
/**
 * -GeoLocation-
 * GeoLocation component
 **/
class GeoLocation extends React.Component {
  state = {
    loading: false,
  };

  getAddress = (address) => {
    return new Promise((resolve, reject) => {
      GoogleMapsLoader.load((google) => {
        geocodeByAddress(address)
          .then((results) => {
            const address = results[0].formatted_address;
            resolve(address);
          })
          .catch((error) => {
            reject("Address lookup error");
          });
      });
    });
  };

  handleClick = (e) => {
    e.preventDefault();

    this.setState({
      loading: true,
    });

    getGeoLocation()
      .then((location) => {
        const lat = location.coords.latitude;
        const lng = location.coords.longitude;
        const address = `${lat} ${lng}`;

        return new Promise((resolve, reject) => {
          this.getAddress(address)
            .then((address) => {
              resolve({ address, lat, lng });
            })
            .catch((error) => {
              reject(error);
            });
        });
      })
      .then((data) => {
        this.props.setLocation(
          this.props.index,
          data.lat,
          data.lng,
          data.address
        );
      })
      .catch((error) => {
        this.props.reportError(error, `locations_${this.props.index}`);
      })
      .then(() => {
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    return (
      <button
        className={`geo-location ${
          this.state.loading ? "is-loading" : "not-loading"
        }`}
        onClick={this.handleClick}
        type="button"
      >
        <span className="assistive-text">Use your location</span>
        <svg className="icon" aria-hidden="true">
          <use
            xlinkHref="#geo_location"
            role="img"
            alt="Use your location"
          ></use>
        </svg>
      </button>
    );
  }
}

export default GeoLocation;

GeoLocation.propTypes = {
  setLocation: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  reportError: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/GeoLocation.js